import { booleanRenderPropertySelector } from 'client/store/config'
import { useSelector } from 'react-redux'
import { RenderProperty } from 'shared/renderProperties'

export const useSocialMediaGallery = (): boolean => {
  const booleanRenderProperty = useSelector(booleanRenderPropertySelector)

  return booleanRenderProperty(RenderProperty.SocialMediaGallery)
}
